import { Flex, Typography, Card } from 'antd';
import { MailOutlined, MessageOutlined } from '@ant-design/icons';
import { Logo } from '../components/logo';

const { Title, Text } = Typography;

export const StartPage = () => {
    return (
        <Flex flex={1} justify={'center'} align={'center'} style={{ width: '100%', height: '100%', background: '#f5f5f5' }}>
            <Card style={{ maxWidth: 500, margin: '20px', textAlign: 'center', borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                <Flex vertical gap={20} align={'center'}>
                    <Flex align="center" gap={12}>
                        <Logo type={'short'} />
                        <Title level={3} style={{ margin: 0 }}>SITEMAX - Contractor</Title>
                    </Flex>

                    <Title level={4} style={{ color: '#1890ff', margin: 0 }}>
                        Welcome to Contractor Portal
                    </Title>

                    <Text style={{ fontSize: 15, color: '#595959' }}>
                        To access your contractor dashboard, please use the secure link sent to your:
                    </Text>

                    <Flex gap={16} align={'center'}>
                        <Flex align="center" gap={6}>
                            <MailOutlined style={{ fontSize: 18, color: '#1890ff' }} />
                            <Text strong>Email</Text>
                        </Flex>
                        <Text type="secondary">or</Text>
                        <Flex align="center" gap={6}>
                            <MessageOutlined style={{ fontSize: 18, color: '#1890ff' }} />
                            <Text strong>SMS</Text>
                        </Flex>
                    </Flex>

                    <Text type="secondary" style={{ fontSize: 13 }}>
                        If you haven't received a link, please contact your administrator.
                    </Text>
                </Flex>
            </Card>
        </Flex>
    );
};
